import { useAppContext } from "../appContext";
import { Element } from "react-scroll";
// Data
import { projectsData } from "../data";
// Components
import { Button, Col, Container, Row } from "react-bootstrap";
import { Title } from "./globalStyledComponents";
import StyledCard from "./StyledCard";

export default function Projects() {
  const { theme } = useAppContext();

  return (
    <Element name={"Projects"} id="projects">
      <section className="section">
        <Container className="text-center">
          <Title>
            <h2>Tools</h2>
            <div className="underline"></div>
          </Title>
          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center row">
                {projectsData.map(function ({
                  id,
                  name,
                  description,
                  link
                }) {
                  return (
                    <Col key={id}>
                      <StyledCard
                        name={name}
                        description={description}
                        url={link}
                      />
                    </Col>
                  );
                })}
              </Row>
        </Container>
      </section>
    </Element>
  );
}
